import { useCanGoBack, useRouter } from "@tanstack/react-router";
import { WEBSITE_URL } from "@unbox/api";
import { ArrowRight } from "@untitledui/icons";
import { Button } from "@/components/base/buttons/button";
import {
  CONSENT_SCREENSHOT_ALT,
  CONSENT_SCREENSHOT_SRC,
  ConnectAdsShell,
  WhyUnboxNeedsAccess,
} from "./connect-ads-shell";

const apiUrl = import.meta.env.VITE_API_URL;

export const PreAuthExplainerPage = ({ merchantId }: { merchantId: string | undefined }) => {
  const router = useRouter();
  const canGoBack = useCanGoBack();
  const referringAppPage = document.referrer.startsWith(`${window.location.origin}/`) ? document.referrer : null;

  const handleContinue = () => {
    if (!merchantId) return;
    window.location.href = `${apiUrl}/tiktok/connect/ads?merchant_id=${encodeURIComponent(merchantId)}`;
  };

  return (
    <ConnectAdsShell>
      <div className="mx-auto max-w-[620px]">
        <div className="flex flex-col">
          <h1 className="text-display-xs font-medium text-primary">Turn on ad account access on TikTok</h1>

          <ol className="mt-5 flex list-decimal flex-col gap-1.5 pl-5 text-sm text-secondary">
            <li>Log in to TikTok.</li>
            <li>
              Tick every field under{" "}
              <span className="font-semibold text-primary">&ldquo;Access Your Ad Account For&rdquo;</span>.
            </li>
            <li>Confirm.</li>
          </ol>

          <div className="mt-5 overflow-hidden rounded-xl border border-secondary bg-white p-6">
            <img src={CONSENT_SCREENSHOT_SRC} alt={CONSENT_SCREENSHOT_ALT} className="w-full" />
          </div>

          <p className="mt-5 text-sm text-tertiary">
            Going forward, keep these permissions on. If any are turned off, we can't exclude or remove videos from your
            TikTok Ads campaigns.
          </p>

          <WhyUnboxNeedsAccess />

          {!merchantId && (
            <p role="alert" className="mt-8 text-sm text-error-primary">
              This link is missing its brand. Please ask your Unbox contact for a new one.
            </p>
          )}

          <div className="mt-8 flex flex-wrap items-center justify-end gap-3">
            {canGoBack ? (
              <Button color="secondary" size="lg" onClick={() => router.history.back()}>
                Cancel
              </Button>
            ) : (
              <Button color="secondary" size="lg" href={referringAppPage ?? WEBSITE_URL}>
                Cancel
              </Button>
            )}
            <Button size="lg" iconTrailing={ArrowRight} onClick={handleContinue} isDisabled={!merchantId}>
              Continue
            </Button>
          </div>
        </div>
      </div>
    </ConnectAdsShell>
  );
};
